import React, { useState } from "react";

import { ROUTES } from "./Route";
import Login from "../Account/Login";
import ServiceTypesManagementScreen from "./ServiceTypesManagement";

export default function ServiceTypesManagement() {
  const [page, setPage] = useState(ROUTES.TRANING_MANAGEMENT);

  switch (page) {
    case ROUTES.TRANING_MANAGEMENT:
      return <ServiceTypesManagementScreen setPage={setPage} />;
    default:
      return <Login />;
  }
}
